module.exports = __webpack_public_path__ + "static/media/click-08.48854ed9.mp3";